import React, { type ReactNode } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { PACKAGE_CLASSNAME } from '../../../constants';
import { useLogoMakerContext } from '../../context/LogoMakerContext';
import { MainRow } from '../MainRow';

const stickyZIndex = theme.zIndex.overlay;
const defaultZIndex = theme.zIndex['1'];

interface LogoMakerLayoutProps {
    children: ReactNode;
    isFullWidth?: boolean;
}

const getPosition = (isSticky: boolean, isTransparent: boolean) => {
    if (isSticky) {
        return 'fixed';
    }
    if (isTransparent) {
        return 'absolute';
    }
    return 'relative';
};

export const LogoMakerLayout = ({ children, isFullWidth = false }: LogoMakerLayoutProps) => {
    const { isSticky, isTransparent } = useLogoMakerContext();

    return (
        <Container
            as="header"
            className={PACKAGE_CLASSNAME}
            style={{ zIndex: isSticky ? stickyZIndex : defaultZIndex }}
            position={getPosition(isSticky, isTransparent)}
            top={isSticky || isTransparent ? 0 : undefined}
            left={isSticky || isTransparent ? 0 : undefined}
            right={isSticky || isTransparent ? 0 : undefined}
            width="100%"
            transform={isSticky ? 'translateZ(0)' : undefined}
            paddingTop="4"
            paddingBottom="4"
            height={{ default: '65px', md: '80px' }}
            borderBottomWidth={isTransparent ? undefined : 'sm'}
            backgroundColor={isTransparent ? 'transparent' : 'white'}
            transition="background-color 0.25s ease, border-color 0.25s ease"
        >
            <MainRow isFullWidth={isFullWidth}>{children}</MainRow>
        </Container>
    );
};
